export default "/assets/website/images/2015.jpg?c993a47014f6e7b78c0e3c21775a5890";